import {Component, OnInit, ViewChild} from '@angular/core';
import {ProductFilterChangedEvent} from '../product-filter/product-filter-changed-event';
import {FilterStorageService} from '../../services/filter-storage.service';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ProgressService} from '../../controls/progress.service';
import {ProductViewModel} from './product-view-model';
import {ProductsService} from '../../api/products.service';
import { ClickEventArgs } from '@syncfusion/ej2-navigations/toolbar';
import {ToastComponent} from '@syncfusion/ej2-angular-notifications';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent implements OnInit {
  private categoryId: string;

  constructor(private filterStorage: FilterStorageService,
              private products: ProductsService,
              private router: Router,
              private route: ActivatedRoute,
              private modalService: NgbModal,
              private progress: ProgressService) {
    this.commands = [ { text: 'Add', tooltipText: 'Add', prefixIcon: 'e-add', id: 'customadd' } ];
  }
  list: ProductViewModel[];
  visibleItems: ProductViewModel[];
  commands: any[];
  textFilter = '';

  @ViewChild('toast', {static: true}) toast: ToastComponent;
  public position = { X: 'Right' };

  async categorySelected($event: ProductFilterChangedEvent) {
    console.log($event);
    this.textFilter = '';
    this.reloadList($event.categoryId);
  }

  toolbar($event: ClickEventArgs) {
    if ($event.item.id === 'customadd') {
      this.add();
    }
  }

  add() {
    if (!this.categoryId) { return; }
    this.router.navigate(['add'], {relativeTo: this.route, queryParams: {categoryId: this.categoryId}});
  }

  ngOnInit() {
  }

  async reloadList(categoryId: string) {
    this.categoryId = categoryId;
    this.list = [];

    if (categoryId == null || categoryId.trim() === '') { return; }

    this.progress.show();
    const organization = this.filterStorage.getSelectedOrganization();
    if (organization != null) {
      const response = await this.products.get(organization.id, categoryId).toPromise();
      this.list = response.data.map(x => new ProductViewModel(x));
    }

    this.textFilter = '';
    this.applyFilter();
    this.progress.hide();
  }

  applyFilter() {
    const textFilter = (this.textFilter || '').trim().toLowerCase();
    let result = this.list;

    if (textFilter.length > 0) {
      result = result.filter(c => {
        return c.product.name.toLowerCase().includes(textFilter);
      });
    }
    this.visibleItems = result;
  }

  edit(data: ProductViewModel) {
    this.router.navigate([data.product.id], {relativeTo: this.route});
  }

  async stateChanged(data: ProductViewModel) {
    console.log(data);
    this.progress.show();
    const organizationId = this.filterStorage.getSelectedOrganization().id;
    try {
      if (data.state) {
        await this.products.activate(organizationId, data.product.id).toPromise();
        this.showToast('In progress', `Activated - ${data.product.name}`);
      } else {
        await this.products.deactivate(organizationId, data.product.id).toPromise();
        this.showToast('In progress', `Deactivated - ${data.product.name}`);
      }
    } catch (e) {
      alert(e.error.message);
      console.error(e);
    } finally {
      this.progress.hide();
    }
  }

  private showToast(title: string, message: string) {
    this.toast.show({
      timeOut: 5000,
      showCloseButton: true,
      title,
      content: message
    });
  }
}
